<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { IMeeting } from '@/stores/meetings';
import AgendaOverlay from '@/views/meetings/AgendaOverlay.vue';
import { ref } from 'vue';

const showAgendaOverlay = ref<boolean>(false);

interface Props {
  meeting: IMeeting;
}

withDefaults(defineProps<Props>(), {});
</script>

<template>
  <div>
    <BasicBlock
      :icon="['fal', 'list']"
      canTriggerOverlay
      @click="showAgendaOverlay = true"
    >
      <p
        class="flex-1"
        :aria-label="
          $t('meeting.agendaPointss_plural', {
            amount: meeting.agendaPoints?.length || 0,
          })
        "
      >
        {{
          $t('meeting.agendaPointss_plural', {
            amount: meeting.agendaPoints?.length || 0,
          })
        }}
      </p>
    </BasicBlock>
  </div>

  <AgendaOverlay
    v-if="showAgendaOverlay"
    :items="meeting.agendaPoints"
    :title="meeting.title"
    @close="showAgendaOverlay = false"
  />
</template>
